import React, { useState } from "react";
import styled from "@emotion/styled";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { RootState } from "../redux/root-store";
import { getImageUrl } from "../utils";
import { Menu, MenuItem } from "@mui/material";
import { setUser } from "../redux/session";
import UserAvatar from "./profile/user-avatar";

const Container = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
`;

const ContentContainer = styled.div`
    flex-grow: 1;
    width: 100%;
    overflow: auto;
`;

const Header = styled.div`
    background-color: #ff575c;
    width: 100%;
    min-height: 50px;
    display: flex;
    align-items: center;
    justify-content: end;
    padding-right: 50px;
`;

const Username = styled.span`
    color: white;
    font-weight: 500;
    margin-left: 10px;
`;

const UserContainer = styled.div`
    display: flex;
    align-items: center;
    &&& {
        cursor: pointer;
    }
`;

const mapStateToProps = (state: RootState) => ({
    loggedUser: state.session.user,
});

const mapDispatchToProps = {
    setUser,
};
type dispatchType = typeof mapDispatchToProps;

interface Props extends ReturnType<typeof mapStateToProps>, dispatchType {
    children?: React.ReactNode;
}

const HeaderLayout = (props: Props) => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const open = anchorEl ? true : false;
    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLogOut = () => {
        props.setUser(null);
    };

    return (
        <Container>
            <Header>
                <UserContainer
                    id="user-button"
                    aria-controls={open ? "user-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                >
                    <UserAvatar
                        src={getImageUrl(props.loggedUser?.profile || "")}
                    />
                    <Username>{props.loggedUser?.name}</Username>
                </UserContainer>
                <Menu
                    id="user-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                        "aria-labelledby": "user-button",
                    }}
                >
                    <Link to="/profile" className="text-black"><MenuItem>Profile</MenuItem></Link>
                    <Link to="/settings" className="text-black"><MenuItem>Settings</MenuItem></Link>
                    <MenuItem onClick={handleLogOut}>Log out</MenuItem>
                </Menu>
            </Header>
            <ContentContainer>{props.children}</ContentContainer>
        </Container>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderLayout);
